import { CollectionSection } from '../../collections/components/CollectionSection';
import { useCollectionApps } from '../../collections/hooks/useCollectionApps';
import { jsx as _jsx } from "react/jsx-runtime";
export function AgentFeaturedCollectionSection({
  featuredCollectionId,
  sectionCount,
  sectionIndex
}) {
  const {
    cards,
    collectionId,
    collectionSlug,
    description,
    hasValidCollectionData,
    queryType,
    title
  } = useCollectionApps(featuredCollectionId);
  if (!hasValidCollectionData) return null;
  return /*#__PURE__*/_jsx(CollectionSection, {
    cards: cards,
    collectionId: collectionId,
    collectionSlug: collectionSlug,
    description: description,
    productType: "AGENT",
    queryType: queryType,
    sectionCount: sectionCount,
    sectionIndex: sectionIndex,
    title: title
  });
}